<template>
    <div>
        <colored-letter-square :name="data.name" :length="2"></colored-letter-square>
    </div>
</template>

<script>

export default {
    props: ['data', 'index'],
}

</script>
